module.exports = __webpack_public_path__ + "img/archive.c46ae8ae.svg";